













































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { BillShortList as IBillList } from "@/api/models/bill-short-list";
import { BillShort as IBill } from "@/api/models/bill-short";
import BillItemPreview from "@/components/bill/BillItemPreview.vue";
import bills, { BillListParams } from "@/getinfo-api/bills";
import { getCurrentCompanyId, getCurrentUserId, isRoot } from "@/plugins/roles";
import { Contract as IContract } from "@/api/models/contract";
import api from "@/getinfo-api";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import CustomTable from "@/components/form/CustomTable.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CField from "@/components/form/CField.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CMultiSelect from "@/components/form/CMultiSelect.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { ContractsListClass } from "@/classes/list/ContractsListClass";
import { BillsSort, SortFields } from "@/plugins/sort-fields";
import { ContractorsListClass } from "@/classes/list/ContractorsListClass";

@Component({
  components: {
    CSingleSelect,
    CMultiSelect,
    CBlock,
    CField,
    CPage,
    CustomButton,
    CustomTable,
    BillItemPreview,
    CustomDatepicker
  }
})
export default class BillList extends Vue {
  bills: Array<IBill> = [];
  contracts: Array<IContract> = [];
  contractId!: string | undefined;
  limit: number = 30;
  offset: number = 0;
  billsCount: number = 0;
  showSpinner: boolean = true;
  formedAtMin!: Date | undefined;
  formedAtMax!: Date | undefined;
  priceMin!: number | undefined;
  priceMax!: number | undefined;
  contractList: ContractsListClass = new ContractsListClass();
  sorted: SortFields<BillsSort> = new SortFields(BillsSort.formedAt);
  isPaid?: boolean;
  contractorType!: "juridical" | "physical" | undefined;
  contractorId!: string | undefined;
  contractorList: ContractorsListClass = new ContractorsListClass({
    companyId: this.selectedCompany
  });

  isSignedAt!: boolean | undefined;
  number!: string | undefined;
  data() {
    return {
      number: undefined,
      isPaid: undefined,
      contractId: undefined,
      formedAtMin: undefined,
      formedAtMax: undefined,
      priceMin: undefined,
      priceMax: undefined,
      contractorId: undefined,
      contractorType: undefined
    };
  }

  get sortStatus() {
    return BillsSort;
  }

  acceptSort(sort: BillsSort) {
    this.sorted.changeSort(sort);
    this.applyFilter();
  }

  applyFilter() {
    this.bills = [];
    this.offset = 0;
    this.getBills();
  }

  clearForm() {
    this.number = undefined;
    this.bills = [];
    this.offset = 0;
    this.billsCount = 0;
    this.contractId = undefined;
    this.priceMax = undefined;
    this.priceMin = undefined;
    this.formedAtMin = undefined;
    this.formedAtMax = undefined;
    this.contractorType = undefined;
    this.contractorId = undefined;
    this.getBills();
  }

  showMore() {
    this.offset += this.limit;
    this.getBills(this.offset);
  }

  updateBillsList() {
    this.bills = [];
    this.offset = 0;
    this.billsCount = 0;
    this.getBills();
  }

  updatePaymentBill(billId: string) {
    let index = this.bills.findIndex(el => {
      return el.id === billId;
    });
    api.BillApi.get(billId).then((res: { data: IBill }) => {
      this.bills[index].payments = res.data.payments;
    });
  }

  getBills(offset: number = 0) {
    this.showSpinner = true;
    let params: BillListParams = {
      companyId: this.selectedCompany ? this.selectedCompany : undefined,
      contractId: this.contractId ? this.contractId : undefined,
      contractorType: this.contractorType,
      contractorId: this.contractorId,
      priceMax: this.priceMax
        ? this.$converter.setPrice(this.priceMax)
        : undefined,
      priceMin: this.priceMin
        ? this.$converter.setPrice(this.priceMin)
        : undefined,
      formedAtMax: this.formedAtMax ? this.formedAtMax : undefined,
      formedAtMin: this.formedAtMin ? this.formedAtMin : undefined,
      limit: this.limit,
      offset: offset,
      isPaid: this.isPaid,
      sort: this.sorted.sort,
      order: this.sorted.order,
      number: this.number
    };

    bills(params)
      .then((res: { data: IBillList }) => {
        this.billsCount = res.data.count;
        res.data?.items?.forEach((element: IBill) => {
          this.bills.push(element);
        });
      })
      .finally(() => {
        this.showSpinner = false;
      });
  }

  @Watch("selectedCompany")
  getContracts() {
    this.contractList.updateCompany();
    this.updateBillsList();
  }

  @Watch("contractorType")
  checkClientType() {
    this.contractorId = undefined;
    this.contractorList.params.type = this.contractorType
      ? this.contractorType
      : undefined;
    this.contractorList.params.offset = 0;
    this.contractorList.listItems = [];
    this.contractorList.list();
  }

  get userId() {
    return getCurrentUserId();
  }

  get root() {
    return isRoot();
  }

  get selectedCompany() {
    return getCurrentCompanyId();
  }

  created() {
    this.getContracts();
  }
}
